module.exports = __webpack_public_path__ + "static/media/performance-order.5b6d7144.svg";